import { useId } from "react";

export default function CrossIcon(props: any) {
  const { onClick, style, className, ...rest } = props;
  const id = useId();
  const gradId = `grad-${id}`;
  const clipId = `clip-${id}`;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={style}
      className={className}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M15.0298 8.97119L8.97266 15.0283M8.97266 8.97119L15.0298 15.0283"
          stroke="#5A534D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0006 21.2858C17.1289 21.2858 21.2863 17.1284 21.2863 12.0001C21.2863 6.87171 17.1289 2.71436 12.0006 2.71436C6.8722 2.71436 2.71484 6.87171 2.71484 12.0001C2.71484 17.1284 6.8722 21.2858 12.0006 21.2858Z"
          stroke="#5A534D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <defs>
        <clipPath id={clipId}>
          <rect width="20" height="20" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
}
